import { Icon } from '@nazka/nazka.mapframe.components';

import { useTranslation } from '@utils/i18n/i18n.consumers';
import { RISK_COLORS } from '@App/pages/RiskDataPage/risk-data-page.constants';
import { HAZARD_CATEGORIES } from '@App/components/AdaptationListComponent/adaptation-list-component.constants';
import { RISK_CATEGORIES } from './risk-data-overview.constants';

import './risk-data-overview.styl';

function RiskDataOverview({ riskData }) {
  const { t } = useTranslation();

  return (
    <div className="risk-data-overview">
      {RISK_CATEGORIES.map(({ id, helpText }) => {
        const riskValue = riskData[id] || 'Unknown';
        const riskInfo = HAZARD_CATEGORIES.find(hazard => hazard.id === id);
        return (
          <div className="risk-data-overview__card" key={id}>
            <Icon
              className="risk-data-overview__card__icon"
              icon={riskInfo?.icon}
              size={id === 'fire' ? { height: '96px', width: '72px' } : '96px'}
              color={RISK_COLORS[riskValue] || '#999'}
            />
            <div className="risk-data-overview__card__title">
              {t(riskInfo?.id)}
            </div>
            <div className="risk-data-overview__card__help">
              {t(helpText, { riskValue: t(riskValue.toLowerCase()) })}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default RiskDataOverview;